import { DesignSystem } from "../design-system.js";
import { TeachingBubble } from "./teaching-bubble.js";
import { styles } from "./teaching-bubble.styles.js";
import { template } from "./teaching-bubble.template.js";
/**
 *
 * @public
 * @remarks
 * HTML Element: <fabric-teaching-bubble>
 */
export const definition = TeachingBubble.compose({
    name: `${DesignSystem.prefix}-teaching-bubble`,
    template,
    styles,
    shadowOptions: {
        mode: DesignSystem.shadowRootMode
    }
});
//# sourceMappingURL=teaching-bubble.definition.js.map